import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { FormStepContainer } from '../../../../styles/FormStepContainer';
import { approvedScreenRegisterViewEvent, ccRatesEvent, creditCardRTREvent } from '../../../../tracking';
import { getPublishedOffers } from '../../../../../../domains/prospect/publishedOffers';

import Default from './MultiproductPersonalizedRate/Default';
import PaidMkt from './MultiproductPersonalizedRate/PaidMkt/PaidMkt';
import PersonalizedRate from './MultiproductPersonalizedRate/PersonalizedRate';

function MultiproductMagic({ publishedOffersLink }) {
  const [rates, setRates] = useState(null);
  const [experimentSource, setExperimentSource] = useState(null);
  const [offerResponse, setOfferResponse] = useState(null);

  useEffect(() => {
    approvedScreenRegisterViewEvent();
    creditCardRTREvent();
  }, []);

  const handleGetPublishedOffers = async () => {
    const response = await getPublishedOffers(publishedOffersLink);
    setOfferResponse(response);

    if (response?.experiments?.paid_marketing === true) {
      setExperimentSource('paid_marketing');
    } else if (response?.experiments?.foundational_test === true) {
      setExperimentSource('foundational_test');
    } else if (response?.experiments?.growth_comms === true) {
      setExperimentSource('growth_comms');
    } else {
      setExperimentSource('default');
    }
  };

  useEffect(() => {
    if (publishedOffersLink) {
      handleGetPublishedOffers();
      ccRatesEvent('rtr');
    }
  }, [publishedOffersLink]);

  // The screen was not being updated with the correct interest rate, so we save the response
  // then we check if the experiment source is different from default
  // and if the interest rate is present in the response, we set it to the rates state
  useEffect(() => {
    if (experimentSource && experimentSource !== 'default') {
      if (offerResponse?.metadata?.revolving_interest_rate) {
        const interestRate = parseFloat(offerResponse.metadata.revolving_interest_rate);
        const percentage = (interestRate * 100).toFixed(2);
        setRates(percentage);
      } else {
        console.error('No interest rate found');
      }
    }
  }, [experimentSource]);

  const displayMultiproductScreen = () => {
    const showZeroRate = rates === null ? false : Number(rates) <= 0;
    switch (experimentSource) {
      case 'paid_marketing':
        return (<PaidMkt showZeroRate={showZeroRate} />);
      case 'foundational_test':
        ccRatesEvent('foundational test');
        return (<PersonalizedRate rates={rates} />);
      case 'growth_comms':
        ccRatesEvent('growth comms');
        return (<PersonalizedRate rates={rates} />);
      case 'default':
      default:
        return (<Default />);
    }
  };

  return (
    <FormStepContainer height="100%">
      { displayMultiproductScreen() }
    </FormStepContainer>
  );
}

MultiproductMagic.propTypes = {
  publishedOffersLink: PropTypes.string,
};

MultiproductMagic.defaultProps = {
  publishedOffersLink: '',
};

export default MultiproductMagic;
